import { lifecycle, compose, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { submit } from 'redux-form'
import { getQuoteItemAndServices } from 'selectors/shoppingData'
import { getCurrentStore, getCurrentStoreEnableAppointmentFlag, getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { getAppointmentFormValues,
  getAppointmentConfirmationFormValues,
  getStickyHeaderValue } from './selectors'
import { scrollToHeader } from 'helpers/scroll'
import { APPOINTMENT_SUCCESS_MESSAGE } from './constants'
import { FORM_NAME } from './../constants'
import Checkout from './Checkout'
import { calculateStickyTop } from './helpers'
import {
  getShowInRangePromoExpirationNotification,
  getShowCallStorePromoExpirationNotification
} from 'components/ShoppingQuote/BOTProductAndServicesQuoteNew/components/PromotionExpirationModal/selectors'
import {
  resetCalendarStartDate,
  resetSkusAddedToCart,
  resetProductsCount
} from 'components/common/hoc/withAddToQuote/actions.js'
import { APPOINTMENT_SCHEDULING_IN_PROGRESS } from 'components/common/UpdatingBlock/constants.js'
import { googleAnalyticPurchase } from 'actions/googleAnalytic'

const mapStateToProps = (state) => {
  const {
    appointmentDate: { date = '', time: { value: timeStr = '' } = {}} = {}
  } = getAppointmentFormValues(state) || {}

  const {
    selectedStore,
    firstName,
    lastName,
    email,
    phoneNumber,
    userPlan
  } = getAppointmentConfirmationFormValues(state) || {}

  const quoteSummary = getQuoteItemAndServices(state)
  const isDateTimeSelected = !!(date && timeStr)
  const currentStore = getCurrentStore(state)
  const isFormFilled = !!(firstName && lastName && email && phoneNumber && userPlan)
  const { services = [], products = []} = quoteSummary
  const { isHeaderSticky } = getStickyHeaderValue(state)

  return {
    selectedStore,
    isDateTimeSelected,
    quoteSummary,
    appointmentSuccessMessage: APPOINTMENT_SUCCESS_MESSAGE,
    currentStore,
    isQuoteReady: !!(Boolean(products.length || services.length)
      && currentStore),
    isFormFilled,
    stickyTop: calculateStickyTop(currentStore, isHeaderSticky),
    appointmentEnable: getCurrentStoreEnableAppointmentFlag(state),
    showCallStorePromoExpirationNotification: getShowCallStorePromoExpirationNotification(state),
    showInRangePromoExpirationNotification: getShowInRangePromoExpirationNotification(state),
    isAppointmentSchedulingInProgress: state.updatingBlocks[APPOINTMENT_SCHEDULING_IN_PROGRESS],
    storePhoneNumber: getCurrentStorePhoneNumber(state)
  }
}

const withCartridgesMapState = withState('cartridgesMap', 'setCartridgesMap', {})

const withCartridgesMapsHandlers = withHandlers({
  buildCartridgesMap: ({ cartridges, setCartridgesMap }) => () => {
    const cartridgesMap = {}
    cartridges.forEach(item => {
      if (Array.isArray(item) && item.length > 0) {
        if (typeof item[0] === 'object' && item[0].props && item[0].props.type) {
          cartridgesMap[item[0].props.type] = item[0]
        }
      } else if (typeof item === 'object' && item.props && item.props.type) {
        cartridgesMap[item.props.type] = item
      }
    })
    setCartridgesMap(cartridgesMap)
  }
})

const withAppointmentInfoLifecycle = lifecycle({
  componentDidMount() {
    const { buildCartridgesMap, cartridges } = this.props

    buildCartridgesMap(cartridges)
  },
  componentDidUpdate({ cartridges: prevCartridges }) {
    const { cartridges, buildCartridgesMap } = this.props

    if (!isEqual(prevCartridges, cartridges)) {
      buildCartridgesMap(cartridges)
    }
  },
  componentWillUnmount() {
    const {
      resetCalendarStartDate,
      resetSkusAddedToCart,
      resetProductsCount
    } = this.props
    resetCalendarStartDate()
    resetSkusAddedToCart()
    resetProductsCount()
  }
})

const withHandleScroll = withHandlers({
  handleScrollTo: () => (id, padding) => {
    const dateTimeElement = document.getElementById(id)
    dateTimeElement && dateTimeElement.focus && dateTimeElement.focus()
    setTimeout(() => scrollToHeader({ element: dateTimeElement, padding: padding || 20 }))
  },
  submitForm: ({ submit, googleAnalyticPurchase }) => () => {
    googleAnalyticPurchase(null)
    submit(FORM_NAME)
  }
})

export default compose(
  withCartridgesMapState,
  withCartridgesMapsHandlers,
  connect(mapStateToProps, {
    submit,
    googleAnalyticPurchase,
    resetCalendarStartDate,
    resetSkusAddedToCart,
    resetProductsCount
  }),
  withAppointmentInfoLifecycle,
  withHandleScroll
)(Checkout)
